import { render, staticRenderFns } from "./RSADetail.vue?vue&type=template&id=12925c86&scoped=true"
import script from "./RSADetail.vue?vue&type=script&lang=js"
export * from "./RSADetail.vue?vue&type=script&lang=js"
import style0 from "./RSADetail.vue?vue&type=style&index=0&id=12925c86&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12925c86",
  null
  
)

export default component.exports